import { Pipe, PipeTransform } from '@angular/core';
import { AnyObject, CardStructureConfig, ItemAttrListDataSet } from '@mri/types';

@Pipe({
  name: 'cardImgRender'
})
export class CardImgRenderPipe implements PipeTransform {

  transform(date: AnyObject, prop: ItemAttrListDataSet, structure: CardStructureConfig<AnyObject>): string | undefined {
    if (typeof structure.img === 'function')
      return structure.img(prop);

    return undefined;
  }

}
